// extracted by mini-css-extract-plugin
module.exports = {"iframe":"youtube_iframe__UzKOD"};